export const SHIPMENTS_CHANGE_VIEW = 'SHIPMENTS_CHANGE_VIEW';
export const shipmentsChangeView = (view, goToPageOne = true) => ({
  type: SHIPMENTS_CHANGE_VIEW,
  viewId: view.id || view,
  goToPageOne,
});

export const SHIPMENTS_SEARCH = 'SHIPMENTS_SEARCH';
export const shipmentsSearch = (searchData) => ({
  type: SHIPMENTS_SEARCH,
  searchData,
});

export const SHIPMENTS_SET_SEARCH_PERFORMED = 'SHIPMENTS_SET_SEARCH_PERFORMED';
export const setSearchPerformed = (wasSearchPerformed) => ({
  type: SHIPMENTS_SET_SEARCH_PERFORMED,
  wasSearchPerformed,
});

export const CLEAR_SEARCH_INPUT = 'CLEAR_SEARCH_INPUT';
export const clearSearchInput = () => ({
  type: CLEAR_SEARCH_INPUT,
});

export const SHIPPING_SEARCH_TERM_CHANGE = 'SHIPPING_SEARCH_TERM_CHANGE';
export const shippingSearchTermChange = (searchValue) => ({
  type: SHIPPING_SEARCH_TERM_CHANGE,
  searchValue,
});
